import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { ChatMode } from 'dragonmouse-shared/interfaces';
import { useSceneChatQueue } from 'hooks/useSceneChatQueue';
import { shallowEqual, useSelector } from 'react-redux';
import { selectActiveScene, selectActiveSceneChat, selectActiveStyle } from 'redux/db/reducers';
import { canEdit } from 'redux/db/util';
import { displayViewOnlyModal } from 'redux/mode/util';
import { RootReducer } from 'redux/reducers';

interface Props {
	label: string;
	prompt: string;
}

const FollowUpAction = ({ label, prompt }: Props) => {
	const { chat, scene, activeStyle } = useSelector(
		(r: RootReducer) => ({
			chat: selectActiveSceneChat(r.db),
			scene: selectActiveScene(r.db, r.mode.activeSceneId),
			activeStyle: selectActiveStyle(r.db, r.mode.activeSceneId),
		}),
		shallowEqual
	);

	const queue = useSceneChatQueue(chat?.id ?? null);
	const clientKey = `followup:${prompt}`;
	const isQueued = queue.items.some((e) => e.clientKey === clientKey);

	const onClick = () => {
		if (!chat || isQueued) return;

		if (!canEdit(scene)) {
			displayViewOnlyModal();
			return;
		}

		queue.enqueue({
			label,
			clientKey,
			payload: {
				kind: 'addUserEntry',
				entry: {
					kind: 'user',
					message: prompt,
					sourceFrameIds: [],
					attachments: [],
				},
				chatMode: ChatMode.DESIGN_AND_CHAT,
				style: activeStyle,
			},
		});
	};

	return (
		<ActionButton
			icon={IconType.GENERATE}
			label={label}
			isQueued={isQueued}
			prompt={prompt}
			onClick={onClick}
		/>
	);
};

export default FollowUpAction;
